// KundenPortalPage.jsx
import React from "react";
import KundenPortalTable from "../KundenPortalTable";

export default function Tab1() {
    return (
        <>
            <KundenPortalTable />
        </>
    )
}
